module.exports = __webpack_public_path__ + "static/media/mask.c42950f4.jpg";